import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ConnectEngine extends ConnectBasicEntity {
engineType: string;
engineValue: string;
visionCode: string;
}

